import { styled } from '@linaria/react';

export const ArrowIconContainer = styled.div<{ active: boolean }>`
	display: flex;
	transform: scale(${({ active }) => (active ? '1,-1' : '1,1')});
	transition: transform 0.2s ease-in-out;

	& > * {
		width: auto;
		height: 100%;
	}
`;
